module.exports = __webpack_public_path__ + "e04516fb943b606c4bc221b0dd411f35.png";